// utils/timeUtils.ts
export const formatTimeForApi = (date: Date): string => {
    return date.toTimeString().split(' ')[0];
};

export const parseApiTime = (time: string): Date => {
    return new Date(`2000-01-01T${time}`);
};

export const formatDaysOfWeek = (daysString: string): string => {
    if (!daysString) return '';
    if (daysString === 'Mon,Tue,Wed,Thu,Fri,Sat,Sun') return 'Every day';
    if (daysString === 'Mon,Tue,Wed,Thu,Fri') return 'Weekdays';
    if (daysString === 'Sat,Sun') return 'Weekends';
    return daysString.split(',').join(', ');
};